import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'

const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectArea
 * @description Select para las Areas registrados en el sistema
 */
const SelectArea = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el area", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {} 
    } = props

    const [ areas, setAreas ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getAreas
     * @description Obitiene las areas
     */
    const getAreas = ({page, limit, search} = areas) => {

        axios.get('/areas', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setAreas(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los areas')
        })
    }

    //componentDidMount
    useEffect(() => {
        getAreas()
    }, [])

    useEffect(() => {
        if(value)
            onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            onSearch={(search)=> getAreas({search})}
            onSelect={(area)=> {
                onChange(area.value)
                onSelect(area.value)
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                areas?.data?.map(({ _id, nombre }) => <Option value={_id}>{nombre ?? ""} {}</Option>)
            }
        </Select>
    );
}



export default SelectArea;